import React, { useEffect, useState } from 'react';
import PubSub from 'services/PubSub';
import SliderProducts from 'components/Home/SliderProductsBanner/SliderProducts';
import ProductsActions from 'actions/Product'
import TitleWithBar from 'components/TitleWithBar';
import { campaignPersonalize } from 'config';
import { actionsType } from 'config/constants';
import LoginService from 'services/Login';
import style from './style.scss';

let actions = [];

const SuggestedProducts = () => {
    const [suggestedProducts, setProducts] = useState(null);
    const [productsLoader, setLoader] = useState(false);
    const [isLogged, setIsLogged] = useState(false);

    const campaignData = campaignPersonalize.homeSuggestedProducts;

    useEffect(() => {
        actions.push(PubSub.register(actionsType.LOGGED_IN, () => {
            setIsLogged(true);
        }));

        return () => {
            actions.map(token => PubSub.unregister(token));
            actions = [];
        }
    }, []);

    useEffect(() => {
        setIsLogged(LoginService.isLogged());
    }, []);

    useEffect(() => {
        if(campaignData && isLogged) {
            setLoader(true);
            return ProductsActions.getRecommended(false, false, campaignData, false, false, false).then((response) => {
                if(response && response.length > 1){
                    setProducts(response);
                }
                setLoader(false);
            });
        }
    }, [isLogged])

    if(!isLogged) return '';

    return (
        <div className="suggested-products">
            <TitleWithBar title="Productos Sugeridos" customClassName="suggested-products-title" />
            <SliderProducts products={suggestedProducts} isLoading={productsLoader} listTitle={'Productos Sugeridos'}/> 
        </div>
    )
}

export default SuggestedProducts;
